import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UpgradeNotificationComponent } from './upgrade-notification.component';
import { ButtonModule } from '@lib/components';
import { StaticMsgModule } from '@lib/pipes';

@NgModule({
  declarations: [UpgradeNotificationComponent],
  imports: [CommonModule, ButtonModule, StaticMsgModule],
  exports: [UpgradeNotificationComponent],
})
export class UpgradeNotificationModule {}
